import React, { type FC } from 'react';

import type { Lucid } from '../../types/types';
import Box from '../box/box';
import Container from '../container/container';
import Divided from './variants/divided';
import Cards from './variants/cards';
import MultiRowStatGrid from './variants/multiRow';

const variantMapping = {
  divided: Divided,
  cards: Cards,
  multiRow: MultiRowStatGrid,
};

export type StatGridProps = {
  /** Allows the component to get additional styles. */
  className?: string;
  /** The main heading for the Stat Grid section */
  heading?: string;
  /** The heading highlight color */
  headingHighlightColor?: Lucid.Theme.Color.ValueKeys | Lucid.Theme.Utility.ProductColorMap;
  /** The stat grid items */
  items?: Lucid.Directus.Generated.Stat_Block[];
  /** The section link */
  link?: Lucid.Directus.Generated.Links;
  /** Used to dynamically update font size based on translated language */
  languageKey?: Lucid.I18n.LanguagesShortCode;
  /** Color of the large statistic text */
  statColor?: Lucid.Theme.Color.ValueKeys | Lucid.Theme.Utility.ProductColorMap;
  /** The text for the Stat Grid section */
  text?: string;
  /** The note for the Stat Grid section */
  note?: string;
  /** The grid item theme variant */
  variant?: keyof typeof variantMapping;
};

const StatGrid: FC<StatGridProps> = ({ className, variant = 'divided', items, ...rest }) => {
  const ComponentVariant = variantMapping[variant];

  return (
    !!items?.length && (
      // eslint-disable-next-line @stylistic/jsx-sort-props
      <Box css={theme => ({ label: 'statGrid', padding: `${theme.space.s104}px 0` })} className={className}>
        <Container css={{ display: 'flex', flexDirection: 'column' }}>
          <ComponentVariant {...rest} items={items} />
        </Container>
      </Box>
    )
  );
};

export { StatGrid };
export default StatGrid;
